module.exports = __webpack_public_path__ + "img/gamma3_banner.d1e1ae89.png";